
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function GallerySection() {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  const galleryImages = [
    {
      id: 1,
      url: 'https://public.readdy.ai/ai/img_res/9e7ca991cb0ca872dac7bd59519e0861.jpg',
      caption: 'The Kominka Exterior',
      captionJa: '古民家の外観',
      description: 'A glimpse of 1970s Tokyo',
    },
    {
      id: 2,
      url: 'https://readdy.ai/api/search-image?query=cozy%20Japanese%20tatami%20living%20room%20with%20chabudai%20low%20table%20floor%20cushions%20and%20traditional%20decor%201970s%20Showa%20era%20interior%20warm%20ambient%20lighting%20film%20grain%20texture%20nostalgic%20home%20atmosphere%20vintage%20aesthetic%20comfortable%20family%20space&width=800&height=600&seq=showa-gallery-002&orientation=landscape',
      caption: 'Living Room',
      captionJa: '居間',
      description: 'Where families gathered',
    },
    {
      id: 3,
      url: 'https://readdy.ai/api/search-image?query=traditional%20Japanese%20bedroom%20with%20futon%20on%20tatami%20mats%20wooden%20beams%20and%20shoji%20screens%201970s%20Showa%20era%20sleeping%20space%20soft%20natural%20light%20film%20photography%20aesthetic%20peaceful%20atmosphere%20vintage%20interior%20design%20minimalist%20zen%20style&width=800&height=600&seq=showa-gallery-003&orientation=landscape',
      caption: 'Bedroom',
      captionJa: '寝室',
      description: 'Sleep on traditional futon',
    },
    {
      id: 4,
      url: 'https://readdy.ai/api/search-image?query=vintage%20Japanese%20kitchen%20from%201970s%20Showa%20era%20with%20retro%20appliances%20wooden%20cabinets%20and%20traditional%20cookware%20warm%20lighting%20nostalgic%20atmosphere%20film%20grain%20texture%20authentic%20period%20details%20functional%20home%20cooking%20space&width=800&height=600&seq=showa-gallery-004&orientation=landscape',
      caption: 'Kitchen',
      captionJa: 'キッチン',
      description: 'Cook with retro appliances',
    },
    {
      id: 5,
      url: 'https://readdy.ai/api/search-image?query=beautiful%20shoji%20paper%20sliding%20doors%20with%20soft%20sunlight%20filtering%20through%20creating%20shadows%20on%20tatami%20floor%20traditional%20Japanese%20interior%201970s%20Showa%20aesthetic%20peaceful%20zen%20atmosphere%20film%20photography%20style%20warm%20tones%20minimalist%20elegance&width=800&height=600&seq=showa-gallery-005&orientation=landscape',
      caption: 'Shoji Light',
      captionJa: '障子の光',
      description: 'Morning light through paper screens',
    },
    {
      id: 6,
      url: 'https://readdy.ai/api/search-image?query=vintage%20black%20rotary%20telephone%20and%20retro%20radio%20on%20wooden%20shelf%20in%20traditional%20Japanese%20home%201970s%20Showa%20era%20nostalgic%20details%20warm%20ambient%20lighting%20film%20grain%20texture%20authentic%20period%20objects%20cultural%20artifacts&width=800&height=600&seq=showa-gallery-006&orientation=landscape',
      caption: 'Retro Details',
      captionJa: 'レトロな小物',
      description: 'Authentic Showa era items',
    },
    {
      id: 7,
      url: 'https://readdy.ai/api/search-image?query=traditional%20Japanese%20engawa%20wooden%20veranda%20overlooking%20small%20garden%20with%20plants%20peaceful%20outdoor%20space%201970s%20Showa%20era%20architecture%20natural%20light%20film%20photography%20aesthetic%20nostalgic%20atmosphere%20vintage%20color%20grading&width=800&height=600&seq=showa-gallery-007&orientation=landscape',
      caption: 'Garden View',
      captionJa: '庭の眺め',
      description: 'Peaceful outdoor space',
    },
    {
      id: 8,
      url: 'https://readdy.ai/api/search-image?query=close%20up%20of%20traditional%20Japanese%20tatami%20mat%20texture%20with%20soft%20lighting%20showing%20woven%20pattern%20and%20natural%20materials%201970s%20Showa%20era%20interior%20detail%20film%20photography%20style%20warm%20tones%20authentic%20craftsmanship%20minimalist%20aesthetic&width=800&height=600&seq=showa-gallery-008&orientation=landscape',
      caption: 'Tatami Texture',
      captionJa: '畳の質感',
      description: 'Traditional craftsmanship',
    },
    {
      id: 9,
      url: 'https://readdy.ai/api/search-image?query=vintage%20Japanese%20movie%20posters%20and%20retro%20wall%20decorations%20from%201970s%20Showa%20era%20hanging%20in%20traditional%20home%20nostalgic%20typography%20warm%20lighting%20film%20grain%20texture%20cultural%20memorabilia%20authentic%20period%20advertising%20art&width=800&height=600&seq=showa-gallery-009&orientation=landscape',
      caption: 'Wall Decor',
      captionJa: '壁の装飾',
      description: 'Original Showa posters',
    },
  ];

  const openLightbox = (id: number) => {
    setSelectedImage(id);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const goToNext = () => {
    if (selectedImage !== null) {
      const currentIndex = galleryImages.findIndex((img) => img.id === selectedImage);
      const nextIndex = (currentIndex + 1) % galleryImages.length;
      setSelectedImage(galleryImages[nextIndex].id);
    }
  };

  const goToPrev = () => {
    if (selectedImage !== null) {
      const currentIndex = galleryImages.findIndex((img) => img.id === selectedImage);
      const prevIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
      setSelectedImage(galleryImages[prevIndex].id);
    }
  };

  const selectedImageData = galleryImages.find((img) => img.id === selectedImage);

  return (
    <section className="py-24 bg-gradient-to-b from-showa-cream to-amber-50 relative overflow-hidden">
      {/* Film grain texture */}
      <div className="absolute inset-0 opacity-20 pointer-events-none film-grain"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-showa-rust font-serif text-sm tracking-[0.3em] uppercase border-b-2 border-showa-rust pb-2">
              Gallery
            </span>
          </div>
          <h2 className="text-5xl font-serif text-showa-brown mb-6 tracking-tight">
            Moments from the Showa Era
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed font-light">
            A visual journey through our 1970s time capsule
          </p>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mt-4 font-light">
            昭和の一コマ一コマ
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image) => (
            <div
              key={image.id}
              onClick={() => openLightbox(image.id)}
              className="group relative aspect-[4/3] overflow-hidden rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer border-4 border-white"
            >
              {/* Image */}
              <img
                src={image.url}
                alt={image.caption}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 sepia-filter"
              />
              
              {/* Film grain overlay */}
              <div className="absolute inset-0 film-grain opacity-50 pointer-events-none"></div>
              
              {/* Warm overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-showa-brown/80 via-showa-brown/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

              {/* Caption overlay */}
              <div className="absolute inset-0 flex flex-col justify-end p-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <h3 className="text-2xl font-serif text-white mb-2 tracking-tight drop-shadow-lg">
                  {image.caption}
                </h3>
                <p className="text-sm text-showa-cream font-medium mb-2 drop-shadow-lg">
                  {image.captionJa}
                </p>
                <p className="text-sm text-white/90 font-light drop-shadow-lg">
                  {image.description}
                </p>
              </div>

              {/* Film strip perforation effect */}
              <div className="absolute top-0 left-0 w-full h-2 bg-showa-brown opacity-60"></div>
              <div className="absolute bottom-0 left-0 w-full h-2 bg-showa-brown opacity-60"></div>
            </div>
          ))}
        </div>

        {/* Bottom text */}
        <div className="text-center mt-16">
          <p className="text-lg text-gray-700 font-serif italic">
            "Every corner holds a memory from 1970s Japan"
          </p>
          <p className="text-sm text-gray-600 mt-2">
            すべての角に昭和の記憶が宿る
          </p>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage !== null && selectedImageData && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          {/* Film strip border effect */}
          <div className="absolute top-0 left-0 w-full h-4 bg-showa-brown opacity-80"></div>
          <div className="absolute bottom-0 left-0 w-full h-4 bg-showa-brown opacity-80"></div>

          {/* Close button */}
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 text-white text-4xl hover:text-showa-yamabuki transition-colors z-10 w-12 h-12 flex items-center justify-center"
            aria-label="Close"
          >
            <i className="ri-close-line"></i>
          </button>

          {/* Previous button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              goToPrev();
            }}
            className="absolute left-6 text-white text-4xl hover:text-showa-yamabuki transition-colors z-10 w-12 h-12 flex items-center justify-center"
            aria-label="Previous"
          >
            <i className="ri-arrow-left-s-line"></i>
          </button>

          {/* Next button */}
          <button
            onClick={(e) => {
              e.stopPropagation();
              goToNext();
            }}
            className="absolute right-6 text-white text-4xl hover:text-showa-yamabuki transition-colors z-10 w-12 h-12 flex items-center justify-center"
            aria-label="Next"
          >
            <i className="ri-arrow-right-s-line"></i>
          </button>

          {/* Image container */}
          <div
            className="relative max-w-6xl max-h-[90vh] w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedImageData.url}
              alt={selectedImageData.caption}
              className="w-full h-full object-contain rounded-sm sepia-filter"
            />
            
            {/* Film grain on lightbox image */}
            <div className="absolute inset-0 film-grain opacity-40 pointer-events-none rounded-sm"></div>

            {/* Caption */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-8 rounded-b-sm">
              <h3 className="text-3xl font-serif text-white mb-2 tracking-tight">
                {selectedImageData.caption}
              </h3>
              <p className="text-lg text-showa-yamabuki font-medium mb-2">
                {selectedImageData.captionJa}
              </p>
              <p className="text-base text-white/90 font-light">
                {selectedImageData.description}
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
